import { render, staticRenderFns } from "./CardProjectActions.vue?vue&type=template&id=0346558a&scoped=true"
import script from "./CardProjectActions.vue?vue&type=script&lang=js"
export * from "./CardProjectActions.vue?vue&type=script&lang=js"
import style0 from "./CardProjectActions.vue?vue&type=style&index=0&id=0346558a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0346558a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2326903440/src/bitbucket.org/Modis-ito/frontend-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0346558a')) {
      api.createRecord('0346558a', component.options)
    } else {
      api.reload('0346558a', component.options)
    }
    module.hot.accept("./CardProjectActions.vue?vue&type=template&id=0346558a&scoped=true", function () {
      api.rerender('0346558a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/drc/components/CardProjectActions.vue"
export default component.exports